<div class="row sticky-top bg-white" style="top:6.125rem">
  <div class="col-md-12">
    <app-alerting></app-alerting>
  </div>
</div>

<div class="pt-3">
  <div class="tab-pane" role="tabpanel">
    <div class="declaration-block">
      <div class="row">
        <div class="col"><h2>Organisation settings</h2></div>
      </div>
    </div>
    <div class="p-4 border rounded-bottom">
      <app-search [ngModel]="organisation?.shortName" [searchFunction]="searchOrganisation"
                  (ngModelChange)="setOrganisation($event)" [resultFormatter]="utils.agentFormatter"
                  placeholder="Find organisation by short name">
      </app-search>
    </div>
    @if (!!organisation) {
      <app-form>
        <div class="p-4 rounded-bottom">
          <app-form-group label="Declares cargo using multiple channels">
            <input [(ngModel)]="organisation.settings.declaresCargoUsingMultipleChannels" class="always-enabled form-check-input m-0" type="checkbox">
          </app-form-group>
          <app-form-group label="Declares ens international">
            <input [(ngModel)]="organisation.settings.declaresEnsInternational" class="always-enabled form-check-input m-0" type="checkbox">
          </app-form-group>
          <app-form-group label="Pilot north sea ports nautical services">
            <input [(ngModel)]="organisation.settings.pilotNorthSeaPortsNauticalServices" class="always-enabled form-check-input m-0" type="checkbox">
          </app-form-group>
          <app-form-group>
            <label>
              <app-info>
                When declaration switches to TSD<span class="tooltipContent">After this visit creation time cargo is declared using TSD</span>
              </app-info>
            </label>
            <app-date-field [(ngModel)]="organisation.settings.tsdTimeFirstIcs2Visit" defaultTime="12:00"></app-date-field>
          </app-form-group>
          <app-form-group label="TSD pilot CRNs">
            <app-multi-search [(ngModel)]="visits" dataKey="crn" (ngModelChange)="pilotCrnsChanged($event)"
                              [inputFormatter]="consignmentUtils.visitFormatter" [resultFormatter]="consignmentUtils.visitFormatter"
                              [minCharacters]="2" [searchFunction]="consignmentUtils.findVisits"
                              placeholder="Find CRN numbers">
            </app-multi-search>
          </app-form-group>
          <div class="row">
            <div class="col-auto ms-auto">
              <button type="submit" class="btn btn-primary" (click)="sendUpsertOrganisationSettings()">Update settings</button>
            </div>
          </div>
        </div>
      </app-form>
    }
  </div>
</div>
